<template>
    <div class="wrapper">
        <div class="row">
            <div class="col">
                <h1 id="welcome">
                    Welcome, {{user.name}}!
                </h1>
                <p id="last-login">
                    Last login: {{lastLoginTime > 0 ? `${lastLoginTime} hours ago` : 'just now'}}
                </p>

                <!-- TODO: Better design -->
                <div class="account-info">
                    <h1>{{loggedinAccount.name}}</h1>
                    <p>Service: <span>{{loggedinAccount.serviceName}}</span></p>
                    <p>Type: <span>{{parseInt(loggedinAccount.type) ? 'productie' : 'test'}}</span></p>
                    <p>Identification: <span>{{loggedinAccount.identification}}</span></p>
                </div>

                <h1 id="getParleyChat">
                    Get Parley
                </h1>
                <p id="chooseMethod">
                    To install Parley, please choose one of the methods:
                </p>

                <div class="row">
                    <div class="doc-link">
                        <a href="https://developers.parley.nu/docs/introduction" target="_blank">
                            <div class="chooseLibrary">
                                <i class="material-icons">desktop_windows</i>
                                <h4>
                                    Web page
                                </h4>
                                <p>
                                    View instructions
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="doc-link">
                        <a href="https://developers.parley.nu/docs/introduction-2" target="_blank">
                            <div class="chooseLibrary">
                                <i class="material-icons">desktop_mac</i>
                                <h4>
                                    iOS
                                </h4>
                                <p>
                                    View instructions
                                </p>
                            </div>
                        </a>
                    </div>

                    <div class="doc-link">
                        <a href="https://developers.parley.nu/docs/introduction-1" target="_blank">
                            <div class="chooseLibrary">
                                <i class="material-icons">android</i>
                                <h4>
                                    Android
                                </h4>
                                <p>
                                    View instructions
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <img src="~@/assets/images/Bitmap.png" class="laptop-image pull-right">
        </div>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    name: 'home',
    mixins: [
        Default
    ],
    components: {},
    data() {
        return {};
    },
    methods: {},
    computed: {
        user: {
            get() {
                return this.$store.getters[this.$store.types.user.getters.get];
            }
        },
        lastLoginTime: {
            get() {
                const timestamp = this.user.lastLogin > 0 ? this.user.lastLogin : Math.floor(Date.now() / 1000);
                const date = new Date(timestamp * 1000);
                const now = new Date();
                const hours = Math.floor(Math.abs(now - date) / 36e5); // 36e5 = 60*60*1000
                return hours;
            }
        },
        loggedinAccount: {
            get() {
                return this.$store.getters[this.$store.types.loggedinAccount.getters.get];
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "../assets/styles/variables";

    .wrapper {
        background: url('../assets/images/right_bg.jpg') no-repeat;
        height: 100vh;
        overflow: auto;
        padding: 5% 0 5% 5%;

        h1#welcome {
            color: #5378B7;
            font-size: 64px;
        }

        #last-login {
            font-size: 14px;
            color: $secondary-color;
            font-weight: 300;
            padding: 0 0 50px 0;
        }

        .account-info {
            margin-bottom: 3em;
            span {
                color: $secondary-color;
            }
        }

        #chooseMethod {
            padding: 0 0 50px 0;
        }

        .doc-link {
            padding-right: 24px;

            a {
                color: inherit;
            }
        }

        .chooseLibrary {
            width: 135px;
            height: 135px;
            background-color: white;
            border: 1px solid #E8EBF0;
            border-radius: 6px;
            text-align: center;
            padding-top: 24px;
            /*margin-right: 24px;*/

            h4 {
                font-size: 14px;
                color: #454D5A;
                font-weight: 400;
                padding: 10px 0;
            }

            p {
                font-size: 10px;
                color: $secondary-color;
                font-weight: 400;
            }
        }

        .laptop-image {
            padding-top: 3%;
            height: 38em;
        }
    }
</style>
